// navigation
export const SET_SHOWTIMES = 'SET_SHOWTIMES';
export const SET_TOGGLE_MODAL = 'SET_TOGGLE_MODAL';

//data
export const SET_PROCURE_MODAL_DATA = 'SET_PROCURE_MODAL_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_USER_TOKEN_DATA = 'SET_USER_TOKEN_DATA';